import React, { useState, useContext, useEffect } from 'react'
import { StackCtx } from 'views/order/v5/comp-factory'
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  ButtonToolbar,
  Button,
  ButtonGroup,
} from 'reactstrap'

export interface PanelAction {
  id: string
  label?: string
  icon?: string
  hint?: string
  style: 'checked' | 'unchecked' | 'cancel' | 'finish'
  onClick?: () => void
  onRender?: (onClose: () => void) => JSX.Element
}

export function Panel(props: {
  id: string
  label: string
  fullHeight?: boolean
  actions?: (PanelAction | null)[]
  actionsTitle?: string
  children: any
  level?: number
  onResize?: (s: { width: number; height: number }) => void
}) {
  const [isActionsOpen, setActionsOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(false)
  const contentRef = React.useRef(null)
  useEffect(() => {
    if (props.onResize && contentRef && contentRef.current) {
      const newSize = { width: contentRef.current.clientWidth, height: contentRef.current.clientHeight }
      // console.log('[PGDBG] onResize', contentRef.current, newSize)
      props.onResize(newSize)
    }
  }, [contentRef.current, props.onResize])

  const levelIndent = { marginLeft: `${(props.level || 0) * 3}ex` }

  const [renderedAction, setRenderedAction] = useState<PanelAction | null>(null)

  const actions = props.actions ? props.actions.filter((x) => !!x) : null

  return (
    <>
      <ul
        className="list-group"
        ref={contentRef}
        style={props.fullHeight ? { height: '100%', ...levelIndent } : { ...levelIndent }}>
        <li className="list-group-item section-header">
          <span key="label">{props.label}</span>
          <span key="actions" className="pull-right">
            <ButtonToolbar>
              <ButtonGroup>
                {actions && (actions.length > 2 || props.actionsTitle) && (
                  <ButtonDropdown
                    isOpen={isActionsOpen}
                    id="add-order-event"
                    key="order-action"
                    className="pull-right"
                    toggle={() => setActionsOpen(!isActionsOpen)}>
                    <DropdownToggle caret={true} color="info" className="btn-sm">
                      {props.actionsTitle || 'Settings'}
                    </DropdownToggle>
                    <DropdownMenu>
                      {actions.map((action) => (
                        <DropdownItem
                          onClick={() => (action.onClick ? action.onClick() : setRenderedAction(action))}
                          key={action.id}>
                          {action.style && action.style == 'checked' && <span className="fa fa-check-circle"></span>}{' '}
                          {action.style && action.style == 'cancel' && <span className="fa fa-remove"></span>}{' '}
                          {action.style && action.style == 'finish' && <span className="fa fa-check"></span>}{' '}
                          {action.icon && <span className={`fa fa-${action.icon}`}></span>} {action.label}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </ButtonDropdown>
                )}
                {actions &&
                  actions.length <= 2 &&
                  !props.actionsTitle &&
                  actions.map((a: PanelAction) => (
                    <Button
                      key={a.id}
                      color={getButtonColor(a.style)}
                      size="sm"
                      onClick={() => (a.onClick ? a.onClick() : setRenderedAction(a))}>
                      {a.style && a.style == 'checked' && <span className="fa fa-check-circle"></span>}{' '}
                      {a.style && a.style == 'cancel' && <span className="fa fa-remove"></span>}{' '}
                      {a.style && a.style == 'finish' && <span className="fa fa-check"></span>}{' '}
                      {a.icon && <span className={`fa fa-${a.icon}`}></span>} {a.label}
                    </Button>
                  ))}
              </ButtonGroup>
            </ButtonToolbar>
          </span>
        </li>
        {props.children}
      </ul>
      {renderedAction && renderedAction.onRender && renderedAction.onRender(() => setRenderedAction(null))}
    </>
  )
}

function getButtonColor(style: PanelAction['style']): string {
  switch (style) {
    case 'cancel':
      return 'danger'
    case 'finish':
      return 'success'
    default:
      return 'info'
  }
}

export function Line(props: { label: string | JSX.Element; highlight?: boolean; children: any }) {
  return (
    <li className={props.highlight ? 'list-group-item-current' : 'list-group-item'}>
      <span>{props.label}: </span>
      <span>{props.children}</span>
    </li>
  )
}
export function Line2(props: { highlight?: boolean; children: any }) {
  return <li className={props.highlight ? 'list-group-item-current' : 'list-group-item'}>{props.children}</li>
}

export function ExtraFieldLine() {
  const stackCtx = useContext(StackCtx)
  if (stackCtx) {
    const label = stackCtx.group ? `${stackCtx.group} / ${stackCtx.name}` : stackCtx.name
    return (
      <Line label={label}>
        <span className="fa fa-keyboard"></span> {stackCtx.value}
      </Line>
    )
  }
  return null
}
